import { createFileRoute } from '@tanstack/react-router';

import { TeamBillingPage } from '@/pages/team-billing/team-billing-page';

export const Route = createFileRoute('/teams/$teamSlug/billing')({
  component: TeamBillingRoute,
});

function TeamBillingRoute() {
  const { teamSlug } = Route.useParams();
  return <TeamBillingPage teamSlug={teamSlug} />;
}
